import { useEffect, useRef } from "react"

import usePostParticipation from "./usePostParticipation"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"
import useConfirmModalAtom from "shared/model/useConfirmModalAtom"

const useGetParticipationState = () => {
    const uuidRef = useRef()
    const isModalOpen = useRef()

    const [fetchResult, fetchRequest] = useFetch()
    const [aletLabel, setAlert] = useAlertModalAtom()
    const [confirmLabel, setConfirm] = useConfirmModalAtom()

    const [postParticipation] = usePostParticipation()

    useEffect(() => {
        if (aletLabel || confirmLabel) isModalOpen.current = true
        else isModalOpen.current = false
    }, [aletLabel, confirmLabel])

    const request = ({ data }) => {
        uuidRef.current = data
        !isModalOpen.current && fetchRequest("GET", `/event/${data}/participation/state`)
    }

    const participationEvent = () => {
        postParticipation(uuidRef.current)
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                if (fetchResult?.data?.is_participation)
                    setConfirm("탈락 처리를 하시겠습니까?", () => participationEvent)
                else
                    setConfirm("참가 등록을 하시겠습니까?", () => participationEvent)
                break
            case 400:
                if (fetchResult?.data?.error_code === "uuid") setAlert("대회 uuid 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("대회 데이터가 존재하지 않습니다.")
                break
        }
    }, [fetchResult])

    return [request]
}

export default useGetParticipationState